import createNEGuardian from '@/utils/KunLun-Web-2.1.5.js'

const RiskControlPlugin = {
  install(Vue, options = {}) {
    const config = {
      productId: 'YD00800801737572',
      apiServer: 'https://rcsdk.migu.cn',
      timeout: 6000,
      businessId: '45f170020b49b6b0de5e6be1a9f8c8d9',
      ...options
    }
    
    let neGuardian = null
    
    const initSDK = () => {
      neGuardian = createNEGuardian(config)
      return neGuardian
    }
    
    const getToken = async (businessId = config.businessId) => {
      if (!neGuardian) {
        throw new Error('SDK未初始化，请先调用initSDK方法')
      }
      return await neGuardian.getToken(businessId)
    }
    
    // 挂载到Vue原型
    Vue.prototype.$riskControl = {
      initSDK,
      getToken,
      config
    }
  }
}

export default RiskControlPlugin